import { render, staticRenderFns } from "./EditorialArticle.vue?vue&type=template&id=ccbeeda0&scoped=true"
import script from "./EditorialArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorialArticle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EditorialArticle.vue?vue&type=style&index=0&id=ccbeeda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbeeda0",
  null
  
)

export default component.exports